import React from 'react'
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { TableRowBackground } from '../../../../utils/colors'
import { useStyles } from './Styles'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const PaymentReceiptMenu = ({ receiptNumber, setCurrentDate }) => {
  let classes = useStyles()
  let intl = useIntl()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [viewReceiptMenu, setViewReceiptMenu] = React.useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setViewReceiptMenu(true)
    setCurrentDate(new Date())
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setTimeout(() => setViewReceiptMenu(false), 500)
    setAnchorEl(null)
  }


  const StyledMenu = withStyles({
    paper: {
      border: `1px solid ${TableRowBackground}`
    }
  })((props) => (
    <Menu
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableScrollLock
      {...props}
    />
  ))

  const generatePDF = () => {
    html2canvas(document.getElementById(`pdfContent-${receiptNumber}`), {
      onclone: function(clonedDoc) {
        clonedDoc.getElementById(`pdfContent-${receiptNumber}`).style.visibility = 'visible'
      },
      x: 0,
      y: 0,
      scrollX: 0,
      scrollY: 0
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const pdf = new jsPDF('p', 'px', 'a4')
        pdf.setProperties({
          title: intl.formatMessage({ id: 'PaymentReceipt.Dialog.Title' }, { rec_num: receiptNumber }),
          subject: 'Info about PDF',
          author: 'PDFAuthor',
          creator: 'E-Finance'
        })
        const imgProps = pdf.getImageProperties(imgData)
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
        pdf.autoPrint({ variant: 'non-conform' })
        let url = URL.createObjectURL(pdf.output('blob'))
        window.open(url, '_blank')
        URL.revokeObjectURL(url)
      })
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      {!!viewReceiptMenu &&
      <StyledMenu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        className={classes.UserCustomMenu}
      >
        <MenuItem onClick={handleClose}>
          <Button color="primary" onClick={generatePDF}>
            <FormattedMessage id='PaymentOrder.ActionLinks.print'/>
          </Button>
        </MenuItem>
      </StyledMenu>
      }
    </div>
  )
}

export default PaymentReceiptMenu
